import {
  createUnifiedTheme,
  palettes,
  createBaseThemeOptions,
} from '@backstage/theme';

// Mercell design tokens — from app.mercell.com CSS variables
const colors = {
  purple50: '#eee8f4',
  purple100: '#cbb8db',
  purple200: '#b196ca',
  purple300: '#8e66b2',
  purple400: '#7849a3',
  purple500: '#561b8c',
  purple600: '#4e197f',
  purple700: '#3d1363',
  purple800: '#2f0f4d',
  purple900: '#240b3b',
  green500: '#4ca88e',
  green800: '#2a5c4e',
  red800: '#810000',
  orange500: '#eb9c03',
  cyan500: '#00a0d1',
  gray50: '#fafafa',
  gray100: '#f5f5f5',
  grey200: '#e8e8e8',
  gray800: '#424242',
  black: '#1a1a1a',
  white: '#ffffff',
};

const mercellPalette = {
  ...palettes.light,
  primary: {
    main: colors.purple800,
    dark: colors.purple900,
    light: colors.purple700,
  },
  secondary: {
    main: colors.green500,
    dark: colors.green800,
    light: '#66d4a3',
  },
  background: {
    default: colors.purple50,
    paper: colors.white,
  },
  text: {
    primary: colors.purple800,
    secondary: colors.gray800,
  },
  navigation: {
    background: colors.gray50,
    color: colors.gray800,
    selectedColor: colors.purple800,
    indicator: colors.purple500,
    navItem: {
      hoverBackground: colors.gray100,
    },
    submenu: {
      background: colors.gray100,
    },
  },
  success: {
    main: colors.green500,
  },
  warning: {
    main: colors.orange500,
  },
  error: {
    main: colors.red800,
  },
  info: {
    main: colors.cyan500,
  },
};

const mercellPageTheme = {
  colors: [colors.purple800, colors.purple800],
  shape: 'none',
  backgroundImage: 'none',
  fontColor: colors.white,
};

export const mercellTheme = createUnifiedTheme({
  ...createBaseThemeOptions({
    palette: mercellPalette,
  }),
  fontFamily:
    'Inter, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif',
  defaultPageTheme: 'home',
  pageTheme: {
    home: mercellPageTheme,
    documentation: mercellPageTheme,
    tool: mercellPageTheme,
    service: mercellPageTheme,
    website: mercellPageTheme,
    library: mercellPageTheme,
    other: mercellPageTheme,
    app: mercellPageTheme,
    apis: mercellPageTheme,
  },
  components: {
    BackstageHeader: {
      styleOverrides: {
        header: {
          backgroundImage: 'none',
          backgroundColor: colors.purple800,
          boxShadow: 'none',
        },
      },
    },
    BackstageSidebar: {
      styleOverrides: {
        drawer: {
          borderRight: `1px solid ${colors.grey200}`,
        },
      },
    },
  },
});
